/*
 * @package module.billing
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class BillingPeriod
 */
import { Type } from 'class-transformer';
import { BillingPeriodRow } from '@/modules/backend/Billing/BillingPeriodRow';

export class BillingPeriod {
  @Type(() => BillingPeriodRow)
  public readonly rows!: BillingPeriodRow[];

  public readonly summary: number = 0;

  @Type(() => Date)
  public readonly to!: Date;

  @Type(() => Date)
  public readonly from!: Date;
}
